import axios from "axios";
import spinnerInterceptor from "../interceptors/spinner.interceptor";
import authTokenInterceptor from "../interceptors/auth-token-iw.interceptor";

const http = axios.create({
  baseURL: window.location.origin
});

authTokenInterceptor.wrapAxios(http);
spinnerInterceptor.wrapAxios(http);

function orderingFetchVendorMenuItemById(venue_id, vendor_id, ids, showSpinner = true, applyToken = true) {
  return http.get(`/ordering/venues/${venue_id}/vendors/${vendor_id}/items?ids=${ids}`, {
    showSpinner,
    applyToken,
    headerType: "Accept",
    headerValue: "application/com.appetize.oapi.item.v2+json"
  });
}

function orderingCalculateCartApi(reqBody, venueId, vendorId, showSpinner = true, applyToken = true) {
  return http.post(`/ordering/venues/${venueId}/vendors/${vendorId}/cart/calculate`, reqBody, {
    showSpinner,
    applyToken,
    headerType: "Content-Type",
    headerValue: "application/com.appetize.oapi.cart.v2+json"
  });
}

function payInitializeSession(reqBody, applyToken = true, showSpinner = true) {
  return http.post(`/ordering/pay/initialize_session`, reqBody, {
    showSpinner,
    applyToken,
    headerType: "Content-Type",
    headerValue: "application/com.appetize.oapi.apl.v1+json"
  });
}

function payPayment(reqBody, applyToken = true, showSpinner = true) {
  return http.post(`/ordering/pay/payment`, reqBody, {
    showSpinner,
    applyToken,
    headerType: "Content-Type",
    headerValue: "application/com.appetize.oapi.apl.v1+json"
  });
}

export default {
  orderingCalculateCartApi,
  orderingFetchVendorMenuItemById,
  payInitializeSession,
  payPayment
};
